import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class AdminCustomStationCode {
  @JsonProperty("Code") code: string;
  @JsonProperty("StationId") stationId: string;
  @JsonProperty("ConnectorId") connectorId: number;
  @JsonProperty("MeterSerialNumber") meterSerialNumber: string;
}
